import IComposableChartsWidget from './IComposableChartsWidget';

export interface IComposableDynamicListingContext {
  businessDefinitionChartsKeys?: (fetchType?: string) => IComposableChartsWidget[];
  businessDefinitionChartsKeysPostgre?: (
    timePeriod?: { id: string; label: string; filterDate: string },
    selectedScope?: any
  ) => IComposableChartsWidget[];
  potentialRevenueForBDefChartsKeys?: (
    timePeriod: { id: string; label: string; filterDate?: string },
    selectedScope?: any
  ) => IComposableChartsWidget[];
  allBusinessDefinition?: IBusinessData[];
  leadByStatusChartsKeys?: (
    timePeriod: { id: string; label: string; filterDate?: string },
    selectedScope?: any
  ) => IComposableChartsWidget[];
  leadStatusList?: StatusList[];
}
interface IBusinessData {
  id?: string;
  stageStatusData: IStageData[];
  createdOn?: Date | string;
  createdBy?: string;
  modifiedOn?: Date | string;
  modifiedBy?: string;
  workspaceId?: string | null;
  businessDefinitionName: string;
  isArchive?: boolean;
  jobOption?: string;
}
interface IStageData {
  stage: string;
  selectedStatuses: string[];
}

interface StatusList {
  label: string;
  value: string;
}

export enum TimeFrequency {
  'TODAY' = 'today',
  '24HR' = '24hr',
  'WTD' = 'wtd',
  '7DAYS' = '7days',
  '30DAYS' = '30days',
  'MTD' = 'mtd',
  'QTD' = 'qtd',
  'LAST_QUARTER' = 'lastQuarter',
  '365DAYS' = '365days',
  'TODAY_UPDATED_ON' = 'today_updatedOn',
  '24HR_UPDATED_ON' = '24hr_updatedOn',
  'WTD_UPDATED_ON' = 'wtd_updatedOn',
  '7DAYS_UPDATED_ON' = '7days_updatedOn',
  '30DAYS_UPDATED_ON' = '30days_updatedOn',
  'MTD_UPDATED_ON' = 'mtd_updatedOn',
  'QTD_UPDATED_ON' = 'qtd_updatedOn',
  'LAST_QUARTER_UPDATED_ON' = 'lastQuarter_updatedOn',
  '365DAYS_UPDATED_ON' = '365days_updatedOn',
}
